<template>
  <button
    type="button"
    role="button"
    aria-label="Back"
    @click="handleClick"
    class="link-back"
  >
    <span class="link-back__icon icon">
      <back-svg />
    </span>
    <span v-if="window.width >= 768" class="link-back__name">{{options.navbar.back}}</span>
  </button>
</template>

<script>
import BackSvg from '../../../../../assets/img/icons/back.svg';
import { mixin } from '../../mixin';

export default {
  name: 'back',
  mixins: [mixin],
  components: {
    BackSvg,
  },
  props: {},
  created() {
    if (window) {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  },
  destroyed() {
    if (window) {
      window.removeEventListener('resize', this.handleResize);
    }
  },
  computed: {
    options() {
      return this.$store.state.siteData;
    },
  },
  methods: {
    handleClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.link-back {
  position: relative;
  z-index: 2;
  margin-right: 20px;
  display: flex;
  align-items: center;

  &__icon {
    display: block;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 1px solid;
    border-color: transparent;
    @include anim(border-color);

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__name {
    margin-top: 2px;
    margin-left: 20px;
    font-family: $f-neutraBold;
    font-size: 12px;
    line-height: 1;
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }

  span {
    display: block;
  }
}
</style>
